module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_7042.75a55a3a.png";